import { render, staticRenderFns } from "./RevenueSplitFinalize.vue?vue&type=template&id=00213ccc&scoped=true"
import script from "./RevenueSplitFinalize.vue?vue&type=script&lang=js"
export * from "./RevenueSplitFinalize.vue?vue&type=script&lang=js"
import style0 from "./RevenueSplitFinalize.vue?vue&type=style&index=0&id=00213ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00213ccc",
  null
  
)

export default component.exports